export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mobile_web.597663d.svg";